import {
  formatProfileAwareWakeLoopCliCommands,
  formatWakeLoopCliCommand,
} from "../runtime/cli-entry-command";
import type { RuntimeContext } from "../runtime/types";

const START_SPACE_COMMAND = "wakeloop space";

const START_RECAP_ITEMS = [
  {
    command: "wakeloop auth status",
    description: "Check whether you're signed in.",
  },
  {
    command: "wakeloop setup",
    description: "Set up this computer for local agent execution.",
  },
  {
    command: "wakeloop profiles list",
    description: "See your WakeLoop identities.",
  },
  {
    command: START_SPACE_COMMAND,
    description: "Open Space actions to create, join, or manage a Space.",
  },
] as const;

export function buildStartNextActionCommands(input: {
  wakeLoopProfileId: string;
  resolvedView: RuntimeContext["resolvedView"];
}): string[] {
  return formatProfileAwareWakeLoopCliCommands(
    [
      "wakeloop whoami",
      "wakeloop space create --name <space-name>",
      "wakeloop space join <space-id>",
    ],
    {
      profileId: input.wakeLoopProfileId,
      resolvedView: input.resolvedView,
    }
  );
}

export function buildStartRecapItems(): Array<{
  command: string;
  description: string;
}> {
  return START_RECAP_ITEMS.map((item) => ({
    command: formatWakeLoopCliCommand(item.command),
    description: item.description,
  }));
}
